import React, { useRef } from 'react'

import Icon from '../icon'

import { Container } from './styles'

import IProps from './props'

const DownloadButton = ({ url }: IProps) => {
  const downloadRef = useRef<HTMLAnchorElement>(null)

  const handleDownload = () => {
    downloadRef.current?.click()
  }

  return (
    <Container onClick={handleDownload}>
      <Icon name="download" />
      <a href={url} download ref={downloadRef}>
        Baixar currículo
      </a>
    </Container>
  )
}

export default DownloadButton
